import Reveal from '@/components/feature/Reveal';

const pillars = [
  {
    icon: 'ri-vip-diamond-line',
    title: 'Quality',
    text: 'A commitment to carefully crafted beer and attention to detail at every stage of the brewing process.',
  },
  {
    icon: 'ri-fingerprint-line',
    title: 'Character',
    text: 'Distinctive brewing is about creating beer with personality, depth, and a clear sense of identity.',
  },
  {
    icon: 'ri-hammer-line',
    title: 'Craftsmanship',
    text: 'Traditional brewing knowledge combined with an independent spirit and a constant focus on quality.',
  },
];

export default function Craft() {
  return (
    <section id="craft" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal className="max-w-2xl">
          <p className="text-xs tracking-[0.35em] uppercase text-primary-600 mb-4">Philosophy</p>
          <h2 className="font-heading font-semibold text-3xl md:text-4xl lg:text-5xl leading-tight text-foreground-950">
            The Craft Behind the Beer
          </h2>
          <p className="mt-5 text-foreground-600 leading-relaxed">
            Three principles guide every batch — an honest dedication to the details that
            define great independent brewing.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {pillars.map((p, i) => (
            <Reveal key={p.title} delay={i * 120}>
              <div className="h-full rounded-lg border border-background-200/70 bg-background-50 p-8 flex flex-col gap-5 hover:border-primary-300 transition-colors">
                <span className="w-14 h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className={`${p.icon} text-2xl`}></i>
                </span>
                <h3 className="font-heading font-semibold text-2xl text-foreground-950">{p.title}</h3>
                <p className="text-foreground-600 leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}